import { getCnpjGestor } from '@/services';

export const RELATORIOS_ALLOWED_GESTOR_CNPJ = '07705530000184';

export function hasCentralRelatoriosAccess(cnpjGestor = getCnpjGestor()): boolean {
  return (cnpjGestor || '').replace(/\D/g, '') === RELATORIOS_ALLOWED_GESTOR_CNPJ;
}
